import React, { useState } from 'react';
import './DownloadBillingReport.scss';
import { Dropdown } from 'primereact/dropdown';
import DropdownItem from '../../dropdown-item/DropdownItem';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { generateReport } from '../../../services/pricing/PricingService';

interface BillingReportProps {
  reportEndCallback: () => void;
}

const DownloadBillingReport: React.FC<BillingReportProps> = ({ reportEndCallback }) => {
  const [range, setRange] = useState<Date[]>([]);
  const [reportType, setReportType] = useState<{ name: string; type: string } | null>(null);
  const [apiError, setAPIError] = useState<string>('');

  const reportTypeOptions: { name: string; type: string }[] = [
    { name: 'Adjustments', type: 'adjustments' },
    { name: 'Transactions', type: 'transactions' },
    { name: 'Products prices', type: 'products_prices' },
    { name: 'Discounts', type: 'discounts' },
    { name: 'Balance', type: 'balance' },
  ];

  const handleSubmit = async () => {
    if (range.length === 0 || !reportType) {
      return;
    }
    const data = {
      range,
      type: reportType.type,
    };

    generateReport(data)
      .then(() => reportEndCallback())
      .catch((err) => setAPIError("You can't generate report"));
  };

  return (
    <div className="form">
      <div className="form__row">
        <div className="form-box__col">
          <div className="form-box__label">Report type:</div>
          <Dropdown
            value={reportType}
            className="dropdown dropdown--disabled"
            optionLabel="name"
            onChange={(e) => {
              setReportType(e.value);
              setAPIError('');
            }}
            options={reportTypeOptions}
            itemTemplate={(option) => <DropdownItem name={option.name} />}
          />
        </div>
      </div>

      <div className="form__row">
        <div className="form-box__col">
          <div className="form-box__label">Range:</div>
          <div className="calendar ">
            <Calendar
              value={range}
              onChange={(e) => {
                setRange(e.value as Date[]);
                setAPIError('');
              }}
              selectionMode="range"
              readOnlyInput
              hideOnRangeSelection
              dateFormat="yy-mm-dd"
              pt={{
                root: {
                  className: 'calendar',
                },
                panel: {
                  className: 'calendar-panel',
                },
              }}
              maxDate={new Date()}
            />
          </div>
        </div>
        {apiError.trim().length > 0 && <span className="form__error">{apiError}</span>}
      </div>

      <Button className="btn btn--sm" label="Download report" onClick={handleSubmit} />
    </div>
  );
};

export default DownloadBillingReport;
